export default "__VITE_ASSET__qalLnrVH__"